import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { setClearAllRefusedDatas } from '../../store/ducks/driver/actions';

export default function useActivateDriver() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  async function execute(driverId: string, callback?: any) {
    try {
      setLoading(true);
      const response = await api.patch(
        `v1/backoffice/drivers/${driverId}/activate`,
      );

      if (response.status === 200) {
        dispatch(setClearAllRefusedDatas());
        if (callback) {
          callback();
        }
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
